import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentsSidebarV2ListGroupHeaderCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-group-header-v2-count-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarV2ListGroupHeaderCount;
